import styled from "@emotion/styled";

export const Actions = styled.div`
  padding-block: 16px;
`;
